import React from 'react';
import PropTypes from 'prop-types';

export default class AutoSavingForm extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    children: PropTypes.any,
    updateAction: PropTypes.func,
    dataValue: PropTypes.any,
    saveMessageClassName: PropTypes.string,
    inline: PropTypes.bool,
    errorMessage: PropTypes.string,
    valueChangeDelay: PropTypes.number
  };

  static defaultProps = {
    inline: false,
    saveMessageClassName: '',
    valueChangeDelay: 5000
  };

  constructor(props){
    super(props);
    this.onValueChange = this.onValueChange.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.setError = this.setError.bind(this);
    this.renderFields = this.renderFields.bind(this);
    this.state = {
      dataValue: props.dataValue,
      message: '',
      hasError: false,
      messageDisplay: 0,
      didSave: false
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.errorMessage){
      this.setMessage(nextProps.errorMessage, true);
    }
    else if(this.state.didSave) {
      this.setMessage("Saved!", false);
    }
  }

  async onValueChange(obj){
    if (this.form.checkValidity()) {
      Object.assign(this.props.data, obj);
      await this.props.updateAction(this.props.data);
      this.setState({ didSave: true });
    }
  }

  setMessage(message, hasError){
    this.setState({ messageDisplay: 1, message, hasError });
    setTimeout(() => this.setState({ messageDisplay: 0, message: null, hasError: false, didSave: false }), 2000);
  }

  setError(error) {
    if (this.state.hasError !== error) {
      this.setState({ messageDisplay: 0, hasError: error });
    }
  }

  renderFields(){
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        data: this.props.data,
        dataValue: this.props.data[child.props.name],
        onValueChange: this.onValueChange,
        valueChangeDelay: this.props.valueChangeDelay,
        setError: this.setError
      });
    }, this);
  }

  render() {
    var style = {
      position: 'relative'
    };

    return (
      <div style={style}>
        <form ref={(form) => (this.form = form)} className={(this.state.hasError ? 'is-invalid': '') + (this.props.inline ? ' form-inline' : '')}>
          <span className={(this.state.hasError ? '' : this.props.saveMessageClassName)} style={{ opacity: this.state.messageDisplay }}>
            {this.state.message}
          </span>
          {this.renderFields()}
        </form>
      </div>
    );
  }
}
